import { styled } from 'parkdepot-shared/theme'

export const NightParkingInnerWrapper = styled('div', ({ $theme }) => ({
    backgroundColor: $theme.colors.white,
    marginTop: '1.2rem'
}))

export const DatepickerWrapper = styled('div', {
    marginTop: '1.6rem'
})

export const DurationWarningTitle = styled('h6', ({ $theme }) => ({
    margin: 0,
    ...$theme.typography.ParagraphSmall,
    fontWeight: 600,
    color: '#000'
}))

export const DurationWarningText = styled('p', ({ $theme }) => ({
    margin: 0,
    ...$theme.typography.ParagraphSmall,
    color: '#000',
    marginBottom: '3.2rem'
}))
